<ng-container *ngIf="field">
  <input
    *ngIf="field.inputType == 'hidden'"
    #inputValue
    type="{{field.inputType}}">

  <mat-form-field
    *ngIf="field.inputType != 'hidden'"
    class="demo-full-width"
    [formGroup]="group"
    appearance="outline"
  >
    <mat-label>
      {{ field.label }}
      <span
        *ngIf="
          field.inputType == 'number' && !!group?.get(field?.key)?.value
        "
      >
        <b>({{ group?.get(field?.key)?.value | number }})</b>
      </span>
    </mat-label>
    <!-- <input
      matInput
      #inputValue
      [formControlName]="field.key || null"
      [placeholder]="field.placeholder || field.label || ''"
      [type]="field.inputType || 'text'"
      [readonly]="field.readonly"
      (change)="fieldChange($event,'change')"
      [min]="field.minInput"
      [max]="field.maxInput"
      (keyup)="fieldChange($event,'keyup')"
      [required]="field.key && group?.get(field.key)?.errors !== null"
    /> -->
    <input
    matInput type="text" id="inputField"
    inputmode="numeric"
    appClickOutside
    [ngModel]="value|numberPipe"
    [readonly]="field.readonly"
    [formControlName]="field.key || null"
    (input)="fieldChange($event,'change')"
    [required]="field.key && group?.get(field.key)?.errors !== null"
    name="inputField">
    <mat-hint align="start" [ngClass]="{ danger: field.hintDanger }">{{
      field.hint
    }}</mat-hint>
    <mat-hint align="end" *ngIf="field.showCounter && field.key"
      >{{ group?.get(field.key)?.value?.length }} /
      {{ field.maxLength }}</mat-hint
    >
    <mat-icon matPrefix *ngIf="field?.icon">{{ field?.icon }}</mat-icon>
    <ng-container
      *ngFor="let validation of field.validations"
      ngProjectAs="mat-error"
    >
      <mat-error
        *ngIf="
          field.key && group?.get(field.key)?.hasError(validation.name)
        "
        >{{ validation.message }}</mat-error
      >
    </ng-container>
  </mat-form-field>
</ng-container>
